'use strict';

const Backbone = require('backbone');

const { extend, pick } = require('underscore');

class BaseView extends Backbone.View {
  constructor(options) {
    super(...arguments);
    this.options = options || {};
    window.BookingTemplates = window.BookingTemplates || {};
    extend(this, pick(this.options, ['templateName', 'module', 'presenter']));
  }

  initialize() {
    this.setModule('booking');
  }

  setModule(module) {
    this.module = module;
  }

  template() {
    return window.BookingTemplates[`${this.module}_frontend_templates_${this.templateName}`];
  }

  getPresenter() {
    if (this.presenter) {
      if (this._presenter == null) {
        this._presenter = new this.presenter(this.options, this.templateName);
      }
      return this._presenter;
    } else {
      return false;
    }
  }

  templateAttributes() {
    if (this.presenter) {
      return this.getPresenter().toHashWithHelpers();
    } else {
      return this.options;
    }
  }

  toHtml() {
    if (this.template()) {
      return this.template().render(this.templateAttributes());
    } else {
      return '';
    }
  }

  render() {
    this.$el.html(this.toHtml());
    return this;
  }

  bhw(widget) {
    if (this.$el != null) {
      this.$el.attr('data-bhw', widget);
    }
  }

  translate() {
    const i18n = this.getPresenter().getI18n();
    return i18n.translate.apply(i18n, arguments);
  }
}

module.exports = BaseView;
